import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius / 2,
    padding: 2,
    paddingLeft: 10,
    paddingRight: 3,
    marginRight: 5,
  },
  content: {
    minWidth: 100,
    maxWidth: 100,
    "& > *": {
      overflow: "hidden",
      maxWidth: "100%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  }
}))

export default useStyles
